import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { 
    ChangeProfileUpdateUserReducer, 
    ProfileUpdateUserReducer, 
    RegisterUsersConnectedProfileReducer 
} from '../../Redux/Actions/Profile/Profile'
import socket from '../../App/socket'
import moment from 'moment'
import { Col, Row, Input, Form, Spin, Select, Collapse } from 'antd'
import { LoadingOutlined, CaretDownOutlined } from '@ant-design/icons'
import SideMenu from '../../Components/Global/SideMenu'

const Perfil = () => {
    const [countrySelected, setCountrySelected] = useState(null)
    const [countrySelectedIcon, setCountrySelectedIcon] = useState(null)
    const [textPhone, setTextPhone] = useState(null)

    const dispatch = useDispatch()
    const { Panel } = Collapse

    const { 
        rex_data_users_online
    } = useSelector(({users}) => users)

    const { 
        rex_data_country_total
    } = useSelector(({paises}) => paises)

    const { 
        rex_data_user_logingrow
    } = useSelector(({loginGrow}) => loginGrow)

    const {
        rex_users_profile_connected,
        rex_profile_user_update,
        rex_loading_profile_user_update,
    } = useSelector(({profile}) => profile)

    useEffect(() => {
        socket.on('get-users-modules', (data_users) => {
            dispatch(RegisterUsersConnectedProfileReducer(data_users))
        })

        return () => {
            socket.emit('unreg-modules', { module: 'status'}, {usuusuario: rex_data_user_logingrow.usuusuario} )
            socket.off('get-users-modules')
        }
    }, [])

    const onFinish = () => {
        dispatch(ProfileUpdateUserReducer())
    }

    const antIcon = (
        <LoadingOutlined
            style={{
                fontSize: '14px',
                color: '#fff'
            }}
            spin
        />
    )

    return (
        <div className='Container-Main Perfil-Container'>
            {/* <NavigationGlobal menuItems={menuUsers}/> */}
            <Form
                layout='vertical'
                className='Perfil-Container-Form'
                autoComplete='off'
            >
                <Row className='Perfil-Container-Text-Main'>
                    <Col>
                        <p className='Perfil-Text-Main'>Mi perfil</p>
                    </Col>
                </Row>
                <Row className='Perfil-Container-Form-Inputs' gutter={20}>
                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}} xl={{span:12}}>
                        <Row>
                            <Form.Item
                                label='Nombres'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="Nombre" 
                                    size='large' 
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e.target.value, 'name'))}
                                    value={
                                        rex_profile_user_update.name
                                        ? rex_profile_user_update.name
                                        : rex_data_user_logingrow.perpersonas
                                            ? rex_data_user_logingrow.perpersonas.pernombre
                                            : null
                                    } 
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Apellidos'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="Apellidos" 
                                    size='large' 
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e.target.value, 'fullname'))}
                                    value={
                                        rex_profile_user_update.fullname
                                        ? rex_profile_user_update.fullname
                                        : rex_data_user_logingrow.perpersonas
                                            ? rex_data_user_logingrow.perpersonas.perapellidos
                                            : null
                                    }
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Posición'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="Posición" 
                                    size='large' 
                                    disabled 
                                    value={
                                        rex_data_user_logingrow.tputiposusuarios
                                        ? rex_data_user_logingrow.tputiposusuarios.tpunombre
                                        : null
                                    }
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Correo corporativo'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="Correo" 
                                    size='large' 
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e.target.value, 'usuario'))}
                                    value={
                                        rex_profile_user_update.usuario
                                        ? rex_profile_user_update.usuario
                                        : rex_data_user_logingrow.usuusuario
                                    }
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Correo personal'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="Correo personal" 
                                    size='large' 
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e.target.value, 'email'))}
                                    value={
                                        rex_profile_user_update.email
                                        ? rex_profile_user_update.email
                                        : rex_data_user_logingrow.usucorreo
                                    }
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Género'
                                className="Perfil-Form-Inputs"
                            >
                                <Select
                                    placeholder="Seleccionar género"
                                    className="Create-User-Form-Gender"
                                    size="large"
                                    suffixIcon={<CaretDownOutlined className="Icon-Gender-Form" />}
                                    popupClassName="Dropdown-User-Form-Gender"
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e, 'gender'))}
                                    options={[
                                        {
                                            value: 1,
                                            label: 'Femenino',
                                        },
                                        {
                                            value: 2,
                                            label: 'Masculino',
                                        }
                                    ]}
                                    value={
                                        rex_profile_user_update.gender
                                        ? rex_profile_user_update.gender
                                        : rex_data_user_logingrow.gnrid
                                    }
                                />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col xs={{span:24}} sm={{span:24}} md={{span:24}} lg={{span:12}} xl={{span:12}} className='Perfil-Container-Input-Right'>
                        <Row>
                            <Form.Item
                                label='Fecha de incorporación'
                                className='Perfil-Input-Date'
                            >
                                <Input 
                                    placeholder="Fecha de incorporación" 
                                    size='large' 
                                    disabled 
                                    value={moment(rex_data_user_logingrow.usufechaincorporacion).format('DD/MM/YY')}
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Acceso a Nivel País'
                                className="Perfil-Form-Inputs"
                            >
                                <Input 
                                    placeholder="País" 
                                    size='large' 
                                    disabled 
                                    value={rex_data_user_logingrow.countries}
                                />
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Celular'
                                className="Perfil-Form-Inputs"
                            >
                                <Collapse 
                                    className="Collapse-Form-User" 
                                    expandIconPosition='end'
                                >
                                    <Panel 
                                        showArrow={false}
                                        key={'1'}
                                        className="Header-Form-User" 
                                        header={
                                            <div style={{display:'flex', alignItems:'center', columnGap:'5px'}}>
                                                {
                                                    countrySelectedIcon != null
                                                    ?   <img className='Image-Country-Select' src={countrySelectedIcon} />
                                                    :   rex_data_country_total.filter(coun => coun.paiprefijo != null).map(coun => {
                                                            if(rex_data_user_logingrow.usutelefono){
                                                                if(coun.paiprefijo == rex_data_user_logingrow.usutelefono.split(' ')[0]){
                                                                    return <img className='Image-Country-Select' src={coun.paiicono} />
                                                                }
                                                            }
                                                        })  
                                                }
                                                <CaretDownOutlined style={{color:'#3B72FF'}}/>
                                                <span>
                                                    {
                                                        rex_profile_user_update.phone
                                                            ?   rex_profile_user_update.phone.split(' ')[0]
                                                            :   rex_data_user_logingrow.usutelefono
                                                                ?   rex_data_user_logingrow.usutelefono.split(' ')[0]
                                                                :   ''
                                                    }
                                                </span>
                                                <Input 
                                                    placeholder="Ingresar teléfono"
                                                    size='large'
                                                    className='Input-Phone-Select'
                                                    onClick={(e) => [
                                                        e.stopPropagation()
                                                    ]}
                                                    onChange={(e) => {
                                                        const phone_number = e.target.value ? e.target.value : ""
                                                        setTextPhone(phone_number)
                                                        const number_value = countrySelected != null ? countrySelected : rex_data_user_logingrow?.usutelefono.split(' ')[0]
                                                        const phone = number_value + " " + phone_number
                                                        dispatch(ChangeProfileUpdateUserReducer(phone, 'phone'))
                                                    }}
                                                    value={
                                                        rex_profile_user_update.phone
                                                        ?   rex_profile_user_update.phone.split(' ')[1]
                                                        :   rex_data_user_logingrow.usutelefono
                                                            ?   rex_data_user_logingrow.usutelefono.split(' ')[1]
                                                            :   ''
                                                    }
                                                />
                                            </div>
                                            }
                                    >
                                        <div className='Collapse-Body'>
                                            {
                                                rex_data_country_total.filter(coun => coun.paiprefijo != null).map(cou => {
                                                    return <div 
                                                        onClick={() => {
                                                            setCountrySelected(cou.paiprefijo)
                                                            setCountrySelectedIcon(cou.paiicono)
                                                            const text_value = textPhone != null ? textPhone : rex_data_user_logingrow?.usutelefono.split(' ')[1]
                                                            const phone = cou.paiprefijo + " " + text_value
                                                            dispatch(ChangeProfileUpdateUserReducer(phone, 'phone'))
                                                        }} 
                                                        className='Container-Option-Select-Country'
                                                    >
                                                        <img className='Image-Country-Select Country-Select' src={cou.paiicono} />
                                                        <span>{cou.painombre}&nbsp;</span>
                                                        <span>{cou.paiprefijo}</span>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </Panel>
                                </Collapse>
                            </Form.Item>
                        </Row>
                        <Row>
                            <Form.Item
                                label='Contraseña'
                                className="Perfil-Form-Inputs"
                            >
                                <Input.Password 
                                    placeholder="Contraseña" 
                                    size='large' 
                                    className="Perfil-Form-Input-Password"
                                    onChange={(e) => dispatch(ChangeProfileUpdateUserReducer(e.target.value, 'password'))}
                                    value={
                                        rex_profile_user_update.password
                                        ?   rex_profile_user_update.password
                                        :   ''
                                    }
                                />
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col span={24} style={{display: 'flex', justifyContent: 'end'}}>
                        <button
                            className='Create-User-Form-Container-Button Create-User-Form-Button-Save'
                            type="primary" 
                            onClick={() => onFinish()}
                        >
                            <span className='Text-Span-Save-User-First'>Actualizar</span>
                            <span className='Text-Span-Save-Create-User'>Actualizar</span>
                            {
                                rex_loading_profile_user_update && <Spin className="Spin-Loading" indicator={antIcon} />
                            }
                        </button>
                    </Col>
                </Row>
            </Form>

            {
                rex_users_profile_connected && 
                    <SideMenu
                        usersCurrentView  = {rex_users_profile_connected}
                        usersAllConnected = {rex_data_users_online}
                    />
            }
        </div>
    )
}

export default Perfil